import {colors} from 'src/assets';
import React from 'react';
import {View} from 'react-native';
import {Icon} from 'src/components';
import {usePreOfferUnreadCount} from 'src/hooks';

export type PreOfferChatTabIconProps = {
  color: string;
};

export const PreOfferChatTabIcon: React.FC<PreOfferChatTabIconProps> = ({
  color,
}) => {
  const [count] = usePreOfferUnreadCount();
  return (
    <View>
      <Icon name="chat" color={color} size={24} />
      {count > 0 && (
        <View
          style={{
            position: 'absolute',
            top: 0,
            right: -10,
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: colors.orange,
          }}
        />
      )}
    </View>
  );
};
